<template>
  <button
    class="rounded-full px-7 py-1 text-white focus:ring-4 focus:ring-dark-blue-500"
    :class="checkIsDisabled"
    type="button"
    :tabindex="tabindex"
    v-on:click="$emit('btn-clicked')"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "Button",
  props: ["label", "isDisabled", "tabindex"],
  computed: {
    /**
     * assigns redness based on property 'isDisabled'
     */
    checkIsDisabled() {
      if (this.isDisabled) {
        return "bg-red-100"
      } else {
        return "bg-red-500"
      }
    },
  },
}
</script>